import { render } from "./ProductAttributeComponent.vue?vue&type=template&id=aee3cc42"
import script from "./ProductAttributeComponent.vue?vue&type=script&lang=js"
export * from "./ProductAttributeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ProductAttribute/ProductAttributeComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aee3cc42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aee3cc42', __exports__)) {
    api.reload('aee3cc42', __exports__)
  }
  
  module.hot.accept("./ProductAttributeComponent.vue?vue&type=template&id=aee3cc42", () => {
    api.rerender('aee3cc42', render)
  })

}


export default __exports__